import { Colors } from "@flatfile/design-system";
import { ZIndex } from "../../../common/UI/ZIndex.js";
import styled from "styled-components";
const DRAG_HANDLE_RIGHT = -5;
const DragHandle = styled.div`
  cursor: col-resize;
  height: 100%;
  position: absolute;
  right: ${DRAG_HANDLE_RIGHT}px;
  top: 0;
  transition: opacity 20ms ease-in;
  width: 10px;

  ::after,
  ::before {
    background-color: ${({ theme }) => theme.column.header.dragHandle.idle};
    content: '';
    position: absolute;
    transition: opacity 60ms ease-in;
    opacity: ${({ dragging }) => dragging ? 1 : 0};
    z-index: 1;
  }

  ::after {
    height: ${({ theme }) => theme.rowHeight}px;
    right: 2px;
    width: 4px;
  }

  ::before {
    height: ${({ dragging }) => dragging ? "var(--table-height)" : "0px"};
    pointer-events: none;
    right: 3px;
    width: 2px;
  }

  :hover {
    z-index: ${ZIndex.level700};

    ::after {
      opacity: 1;
      right: calc(50% - 3px);
      background-color: ${({ theme }) => theme.column.header.dragHandle.dragging};
    }

    ::before {
      opacity: 1;
      width: 0;
      background-color: ${Colors.White} !important;
      border: ${({ theme }) => `1px dashed ${theme.column.header.dragHandle.dragging}`};
      right: calc(50% - 2px);
    }
  }
`;
export {
  DRAG_HANDLE_RIGHT,
  DragHandle
};
